import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "src/store/hooks";
import { selectServerPlanEntities, selectServerPlanIds } from "src/store/mine_craft/serverPlansSlice";

import Card from "./_Card";

const _ListGrid = () => {
  const ids   = useAppSelector(selectServerPlanIds);
  const plans = useAppSelector(selectServerPlanEntities);

  const renderPlan = (id: EntityId) => {
    const plan = plans[id];

    if (!plan) {
      return null;
    }

    return <Card key={`plan-${id}`} plan={plan} />;
  }

  return (
    <div className='v-plan-cards'>
      {ids && ids.map(renderPlan)}
    </div>
  );
}

export default _ListGrid;
